import { Module } from "vuex";
import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { IRootState } from "../types";
import { ProfileState } from "./types";

export const state: ProfileState = {
  age: undefined,
  postcode: "",
  gender: undefined
};

export const namespace = "profile";

const namespaced: boolean = true;

export const profile: Module<ProfileState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
